import * as T from '../constants/types';
import { throwError } from './throwNotification';
import { onToggleLayer } from './onToggleLayer';
import { parseGeoJsonFile, buildUniqueLayerId, buildUserLayerDefinition } from '../utils/userGeoJson';
import { USER_LAYERS_GROUP_ID, USER_LAYERS_GROUP_LABEL, isUserLayerId } from '../constants/userLayers';

// Собирает id всех уже загруженных пользовательских слоёв — для уникализации имени.
const existingUserLayerIds = layers => layers
    .filter(({ id }) => id === USER_LAYERS_GROUP_ID)
    .flatMap(({ layers: groupLayers = [] }) => groupLayers.map(({ id }) => id))
    .filter(isUserLayerId);

// Читает перетащенный файл, добавляет слой в группу «Пользовательские слои» и сразу включает его.
export const addUserGeoJsonLayer = file => async (dispatch, getState) => {
    let parsed;
    try {
        parsed = await parseGeoJsonFile(file);
    } catch (error) {
        dispatch(throwError({ message: `${file.name}: ${error.message}` }));
        return;
    }

    const { map: { layers } } = getState();
    const id = buildUniqueLayerId(parsed.name, existingUserLayerIds(layers));
    const layerDefinition = buildUserLayerDefinition({ ...parsed, id });

    dispatch({
        type: T.ADD_USER_GEOJSON_LAYER,
        payload: {
            groupId: USER_LAYERS_GROUP_ID,
            groupLabel: USER_LAYERS_GROUP_LABEL,
            layer: layerDefinition,
        },
    });

    // Слой создаётся с visibility: 'none' — тоггл включает его и попутно ставит
    // переключатель в сайдбаре в активное состояние.
    dispatch(onToggleLayer(layerDefinition.id, layerDefinition.additionalLayers));
};

// Пакетная обработка: на карту можно бросить сразу несколько файлов.
export const addUserGeoJsonFiles = files => async dispatch => {
    if (!files.length) return;
    for (const file of files) {
        await dispatch(addUserGeoJsonLayer(file));
    }
};
